angular
    .module('questionarioAdv.module', [])
    .component('questionarioAdv', {
        templateUrl: 'ng/components/questionarioAdv/questionarioAdv.view.html',
        bindings: {
            listQuestions: '<',
            responseQuestionario: '<',
            changeIndex: '&',
            isPagoDopo: '<',
            hideInternalFooter: '<',
            exportModelForDigital: '&',
            leasingData: '<',
            isLo: '<',
            continueLoRiProcess: '&',
            saveDraftLo: '&',
            standalone: '<',
            digitalNavigator: "<?",
            externalLink: '<',
            digitalProcess: '<',
            readOnly: '<?'
        },
        controllerAs: 'qstAdvCtrl',
        controller: QuestionarioAdvCtrl
    })

function QuestionarioAdvCtrl(
    $uniService,
    $location,
    $portalService,
    $timeout,
    $modalService,
    $rootScope,
    $istatService,
    $scope,
    $configService,
    $financialApiService,
    FileUploader,
    $download,
    $simulationService
) {
    var self = this;

    self.$onInit = function () {
        self.isAru = $portalService.isAru();
        self.doNotModify = self.responseQuestionario.status === 'SEND_PV' || self.readOnly || self.responseQuestionario.readOnly ? true : false;
        if (!self.externalLink && !self.isPagoDopo) {
            self.isFiduciarieFull = $configService
                .getAppConfig()
                .allFunctionalities.includes("FIDUCIARIE_FULL")
                ? true
                : false;
        }
        self.$rootScope = $rootScope;
        self.enabledPrintButton = false;
        self.listaNazioni = $rootScope.nazioniEstere;
        self.validateQuest = {
            introduttiva: false,
            cliente: false,
            esecutore: false,
            titolari: false,
            operazione: false,
            note: false,
            fiduciarie: true,
            fiduciante: true,
            correzione: true,
            firmatari: false
        }

        self.loading = {
            submit: false,
            back: false,
            suspend: false
        }

        // if (self.responseQuestionario ) {
        //     Object.assign(self.responseQuestionario, {
        //         forzata: true
        //     })
        // }

        if (self.listQuestions && self.listQuestions.documento && !self.listQuestions.documento.visible) {
            self.validateDocumento(!self.listQuestions.documento.visible)
        }

        self.loadingStatus = {
            uploading: false,
        };

        getEventLog(self.responseQuestionario.id);

    }

    $scope.$on("suspendDigitalLeasing", function (e) {
        self.pause();
    });


    var getListNazioni = function () {
        $istatService.getNazioni()
            .then(function (response) {
                self.listaNazioni = response.domainList.filter(
                    function (element) {
                        return !element.deleted
                    });

            })
    }

    self.newTitolari = function (nuoviTitolari) {
        self.nuoviTitolari = nuoviTitolari;
    }

    self.newExecut = function (nuoviEsecutori) {
        self.nuoviEsecutori = nuoviEsecutori
    }

    self.newFiduciarieFn = function (nuoveFiduciarie) {
        self.nuoveFiduciarie = nuoveFiduciarie
    }

    self.newFiduciante = function (nuovoFiduciante) {
        self.nuovoFiduciante = nuovoFiduciante
    }

    self.next = function (fromModal, fromModalArmamenti) {
        functionToExport();

        if(self.responseQuestionario.metadataAdv.note.noteCommon.domandaArmamenti && !fromModalArmamenti && !self.responseQuestionario.metadataAdv.note.noteCommon.domandaArmamentiConferma) {
            $modalService.openModal("domandaArmamenti-modal");
            return;
        } else if(self.responseQuestionario.metadataAdv.note.noteCommon.domandaArmamenti && fromModalArmamenti) {
            self.responseQuestionario.metadataAdv.note.noteCommon.domandaArmamentiConferma = true;
            $modalService.closeModal("domandaArmamenti-modal");
        }
        
        if(self.responseQuestionario.metadataAdv.note.noteCommon.domandaArmamenti && self.responseValidateRequest) {
            self.responseQuestionario.userCanForce = self.responseValidateRequest.userCanForce;
        }

        self.loading.submit = true;
        if (fromModal) {
            if ($portalService.isAra() && !self.isLo) {
                self.responseQuestionario.warningForzatura = true;
                var fiduciarieNonAnnullate = self.responseQuestionario.metadataAdv.fiduciarie.fiduciarie
                    .filter(x => {
                        return !x.annullatoFe
                    });

                $uniService.submitADV(self.responseQuestionario)
                    .then(function (response) {
                        if (response.success) {
                            if (response.keyMessage && response.keyMessage == 'WARNING_ADV_PRV') {
                                $rootScope.$broadcast("addAlert", {
                                    text: "WARNING_ADV_PRV"
                                })
                            } else if (response.keyMessage && response.keyMessage == 'WARNING_ADV_CORREZIONE') {
                                $rootScope.$broadcast("addAlert", {
                                    text: "WARNING_ADV_CORREZIONE"
                                })

                            } else {
                                $rootScope.$broadcast("addAlert", {
                                    text: "MSG_ADV_OK"
                                })
                            }

                            $timeout(function () {
                                self.loading.submit = false;
                                $modalService.closeModal("validateRequest-modal");
                                if (self.isPagoDopo) {
                                    window.close();
                                } else {

                                    self.changeIndex({
                                        value: 0,
                                        clearSearch: true
                                    })

                                }
                            }, 5000)
                        } else {
                            self.submitError = !self.submitError
                            self.loading.submit = false;
                        }

                    })
                    .catch(function (error) {
                        console.log(error);
                        self.loading.submit = false;
                        self.submitError = !self.submitError
                    })


            } else if ($portalService.isAru()) {
                var fiduciarieNonAnnullate = self.responseQuestionario.metadataAdv.fiduciarie.fiduciarie
                    .filter(x => {
                        return !x.annullatoFe
                    });

                $uniService.submitQuestADV(self.responseQuestionario)
                    .then(function (response) {
                        if (response.success) {

                            if (response.keyMessage && response.keyMessage == 'WARNING_ADV_PRV') {
                                $rootScope.$broadcast("addAlert", {
                                    text: "WARNING_ADV_PRV"
                                })
                            } else if (response.keyMessage && response.keyMessage == 'WARNING_ADV_CORREZIONE') {
                                $rootScope.$broadcast("addAlert", {
                                    text: "WARNING_ADV_CORREZIONE"
                                })

                            } else {
                                $rootScope.$broadcast("addAlert", {
                                    text: "MSG_ADV_OK"
                                })
                            }
                            $modalService.closeModal("validateRequest-modal");
                            self.loading.submit = false;
                            if (self.isPagoDopo) {
                                window.close();
                            } else {
                                $location.path("/")
                            }
                        } else {
                            self.submitError = !self.submitError
                            self.loading.submit = false;
                        }

                    })
                    .catch(function (error) {
                        console.log(error);
                        self.loading.submit = false;
                        self.submitError = !self.submitError
                    })
            } else if (self.isLo) {
                self.responseQuestionario.warningForzatura = true;
                var fiduciarieNonAnnullate = self.responseQuestionario.metadataAdv.fiduciarie.fiduciarie
                    .filter(x => {
                        return !x.annullatoFe
                    });

                $uniService.submitADVLO(self.responseQuestionario)
                    .then(function (response) {
                        $modalService.closeModal("validateRequest-modal");

                        if (response.success) {
                            if (response.keyMessage && response.keyMessage == 'WARNING_ADV_PRV') {
                                $rootScope.$broadcast("addAlert", {
                                    text: "WARNING_ADV_PRV"
                                })
                            } else if (response.keyMessage && response.keyMessage == 'WARNING_ADV_CORREZIONE') {
                                $rootScope.$broadcast("addAlert", {
                                    text: "WARNING_ADV_CORREZIONE"
                                })

                            } else {
                                $rootScope.$broadcast("addAlert", {
                                    text: "MSG_ADV_OK"
                                })
                            }
                            $timeout(function () {
                                self.continueLoRiProcess();
                            }, 5000)
                        } else {
                            self.submitError = !self.submitError
                        }
                        self.loading.submit = false;

                    })
                    .catch(function (error) {
                        $modalService.closeModal("validateRequest-modal");

                        console.log(error);
                        self.loading.submit = false;
                        self.submitError = !self.submitError

                    })
            }

        } else {
            if (self.nuoviTitolari && self.nuoviTitolari.length) {

                self.nuoviTitolari.forEach(function (element) {
                    var checkCfIsPresent = self.responseQuestionario.metadataAdv.titolari.titolari.some(function (titolare) {
                        return titolare.cf == element.cf
                    })
                    if (!checkCfIsPresent) {
                        self.responseQuestionario.metadataAdv.titolari.titolari.push(element)
                    }
                })
            }

            if (self.nuoviEsecutori && self.nuoviEsecutori.length) {

                self.nuoviEsecutori.forEach(function (element) {
                    var checkCfIsPresent = self.responseQuestionario.metadataAdv.esecutori.esecutori.some(function (titolare) {
                        return titolare.cf == element.cf
                    })
                    if (!checkCfIsPresent) {
                        self.responseQuestionario.metadataAdv.esecutori.esecutori.push(element)
                    }
                })
            }

            if (self.nuoveFiduciarie && self.nuoveFiduciarie.length) {
                if (!self.responseQuestionario.metadataAdv.fiduciarie) {
                    self.responseQuestionario.metadataAdv.fiduciarie = {
                        fiduciarie: []
                    }
                }
                self.responseQuestionario.metadataAdv.fiduciarie.fiduciarie = self.responseQuestionario.metadataAdv.fiduciarie.fiduciarie.concat(self.nuoveFiduciarie);

                self.nuoveFiduciarie.forEach(function (element) {
                    var checkCfIsPresent = self.responseQuestionario.metadataAdv.fiduciarie.fiduciarie.some(function (titolare) {
                        return titolare.cf == element.cf
                    })
                    if (!checkCfIsPresent) {
                        self.responseQuestionario.metadataAdv.fiduciarie.fiduciarie.push(element)
                    }
                })
            }

            if (self.nuovoFiduciante && self.nuovoFiduciante.length) {
                if (!self.responseQuestionario.metadataAdv.fiducianti) {
                    self.responseQuestionario.metadataAdv.fiducianti = {
                        fiducianti: []
                    }
                }
                self.nuovoFiduciante.forEach(function (element) {
                    var checkCfIsPresent = self.responseQuestionario.metadataAdv.fiducianti.fiducianti.some(function (titolare) {
                        return titolare.cf == element.cf
                    })
                    if (!checkCfIsPresent) {
                        self.responseQuestionario.metadataAdv.fiducianti.fiducianti.push(element)
                    }
                })
            }
            self.responseQuestionario.metadataAdv = self.listQuestions;
            self.resetModel = !self.resetModel;
            if ($portalService.isAra() && !self.isLo) {
                var fiduciarieNonAnnullate = self.responseQuestionario.metadataAdv.fiduciarie.fiduciarie
                    .filter(x => {
                        return !x.annullatoFe
                    });


                $uniService.validateRequestAdv(self.responseQuestionario)
                    .then(function (response) {
                        if (response.details.showPopup) {
                            self.loading.submit = false;
                            $modalService.openModal("validateRequest-modal");
                            self.responseValidateRequest = response;
                            self.resetModel = !self.resetModel;
                        } else {
                            var fiduciarieNonAnnullate = self.responseQuestionario.metadataAdv.fiduciarie.fiduciarie
                                .filter(x => {
                                    return !x.annullatoFe
                                });

                            $uniService.submitADV(self.responseQuestionario)
                                .then(function (response) {
                                    if (response.success) {
                                        if (response.keyMessage && response.keyMessage == 'WARNING_ADV_PRV') {
                                            $rootScope.$broadcast("addAlert", {
                                                text: "WARNING_ADV_PRV"
                                            })
                                        } else if (response.keyMessage && response.keyMessage == 'WARNING_ADV_CORREZIONE') {
                                            $rootScope.$broadcast("addAlert", {
                                                text: "WARNING_ADV_CORREZIONE"
                                            })

                                        } else {
                                            $rootScope.$broadcast("addAlert", {
                                                text: "MSG_ADV_OK"
                                            })
                                        }
                                        if (self.isPagoDopo) {
                                            window.close();
                                        } else {
                                            self.changeIndex({
                                                value: 0,
                                                clearSearch: true
                                            })
                                        }
                                    } else {
                                        self.submitError = !self.submitError;
                                    }
                                    self.loading.submit = false;
                                })
                                .catch(function (error) {
                                    console.log(error);
                                    self.loading.submit = false;
                                })

                        }

                    })
                    .catch(function (error) {
                        self.loading.submit = false;
                        self.submitError = !self.submitError;
                    })

            } else if ($portalService.isAru()) {
                var fiduciarieNonAnnullate = self.responseQuestionario.metadataAdv.fiduciarie.fiduciarie
                    .filter(x => {
                        return !x.annullatoFe
                    });


                $uniService.validateRequestAdv(self.responseQuestionario)
                    .then(function (response) {
                        if (response.details.showPopup) {
                            self.loading.submit = false;
                            $modalService.openModal("validateRequest-modal");
                            self.responseValidateRequest = response;
                        } else {
                            var fiduciarieNonAnnullate = self.responseQuestionario.metadataAdv.fiduciarie.fiduciarie
                                .filter(x => {
                                    return !x.annullatoFe
                                });

                            $uniService.submitQuestADV(self.responseQuestionario)
                                .then(function (response) {
                                    if (response.success) {
                                        if (response.keyMessage && response.keyMessage == 'WARNING_ADV_PRV') {
                                            $rootScope.$broadcast("addAlert", {
                                                text: "WARNING_ADV_PRV"
                                            })
                                        } else if (response.keyMessage && response.keyMessage == 'WARNING_ADV_CORREZIONE') {
                                            $rootScope.$broadcast("addAlert", {
                                                text: "WARNING_ADV_CORREZIONE"
                                            })

                                        } else {
                                            $rootScope.$broadcast("addAlert", {
                                                text: "MSG_ADV_OK"
                                            })
                                        }
                                        if (self.isPagoDopo) {
                                            window.close();
                                        } else {
                                            $location.path("/")
                                        }
                                    } else {
                                        self.submitError = !self.submitError;
                                    }
                                    self.loading.submit = false;
                                })
                                .catch(function (error) {
                                    console.log(error);
                                    self.loading.submit = false;
                                    self.submitError = !self.submitError;
                                })

                        }

                    })
                    .catch(function (error) {
                        self.loading.submit = false;
                        self.submitError = !self.submitError;
                    })

            } else if (self.isLo) {
                var fiduciarieNonAnnullate = self.responseQuestionario.metadataAdv.fiduciarie.fiduciarie
                    .filter(x => {
                        return !x.annullatoFe
                    });


                $uniService.validateRequestAdv(self.responseQuestionario)
                    .then(function (response) {
                        if (response.details.showPopup) {
                            self.loading.submit = false;
                            $modalService.openModal("validateRequest-modal");
                            self.responseValidateRequest = response;
                        } else {
                            var fiduciarieNonAnnullate = self.responseQuestionario.metadataAdv.fiduciarie.fiduciarie
                                .filter(x => {
                                    return !x.annullatoFe
                                });

                            $uniService.submitADVLO(self.responseQuestionario)
                                .then(function (response) {
                                    if (response.success) {
                                        if (response.keyMessage && response.keyMessage == 'WARNING_ADV_PRV') {
                                            $rootScope.$broadcast("addAlert", {
                                                text: "WARNING_ADV_PRV"
                                            })
                                        } else if (response.keyMessage && response.keyMessage == 'WARNING_ADV_CORREZIONE') {
                                            $rootScope.$broadcast("addAlert", {
                                                text: "WARNING_ADV_CORREZIONE"
                                            })

                                        } else {
                                            $rootScope.$broadcast("addAlert", {
                                                text: "MSG_ADV_OK"
                                            })
                                        }
                                        self.continueLoRiProcess();
                                    } else {
                                        self.submitError = !self.submitError;
                                    }
                                    self.loading.submit = false;
                                })
                                .catch(function (error) {
                                    console.log(error);
                                    self.loading.submit = false;
                                })
                        }
                    })

            }
        }

    }

    self.back = function () {
        self.loading.back = true;
        $timeout(function () {
            self.changeIndex({
                value: 0
            })
            self.loading.back = false;
        }, 2000)
    }

    self.validateIntroduttiva = function (valueOfValid) {
        self.validateQuest.introduttiva = valueOfValid;

        checkQuestionary();
    }

    self.validateCliente = function (valueOfValid) {
        self.validateQuest.cliente = valueOfValid;
        checkCatenaSelected();
        checkQuestionary();
    }

    self.validateModalitaFirma = function (valueOfValid) {
        self.validateQuest.modalitaFirma = valueOfValid;
        checkQuestionary();
    }

    self.validateEsecutore = function (valueOfValid) {
        self.validateQuest.esecutore = valueOfValid;

        checkQuestionary();
    }

    self.validateOperazione = function (valueOfValid) {
        self.validateQuest.operazione = valueOfValid;

        checkQuestionary();
    }

    self.validateTitolari = function (valueOfValid) {
        self.validateQuest.titolari = valueOfValid;

        checkQuestionary();
    }

    self.validateFirmatari = function (valueOfValid) {
        self.validateQuest.firmatari = valueOfValid;

        checkQuestionary();
    }

    self.validateNote = function (valueOfValid) {
        self.validateQuest.note = valueOfValid;

        checkQuestionary();
    }

    self.validateFiduciarie = function (valueOfValid) {
        self.validateQuest.fiduciarie = valueOfValid;

        checkQuestionary();
    }

    self.validateFiduciante = function (valueOfValid) {
        self.validateQuest.fiduciante = valueOfValid;

        checkQuestionary();

    }

    self.validateCorrezione = function (valueOfValid) {
        self.validateQuest.correzione = valueOfValid;

        checkQuestionary();
    }


    var checkQuestionary = function () {
        if (self.listQuestions.correzione && self.listQuestions.correzione.daCorreggere) {
            self.enableSubmitButton = self.validateQuest.correzione
        } else {
            self.enableSubmitButton =
                self.validateQuest.introduttiva &&
                self.validateQuest.cliente &&
                (self.validateQuest.modalitaFirma || !self.listQuestions.isPostVendita) &&
                (self.validateQuest.operazione || !self.listQuestions.operazione.visible) &&
                (self.validateQuest.titolari || !self.listQuestions.titolari.visible || self.showHideFiduciaria) &&
                (self.validateQuest.firmatari || !self.responseQuestionario.firmaDigitale || !self.listQuestions.isPostVendita) &&
                self.validateQuest.note &&
                self.validateQuest.documento &&
                (self.validateQuest.fiduciante || !self.showHideFiduciaria || !self.isFiduciarieFull);
        }
        $timeout(function () {


            self.enabledPrintButton =
                self.validateQuest.introduttiva &&
                self.validateQuest.cliente &&
                (self.validateQuest.modalitaFirma || !self.listQuestions.isPostVendita) &&
                (self.validateQuest.operazione || !self.listQuestions.operazione.visible) &&
                (self.validateQuest.titolari || !self.listQuestions.titolari.visible || self.showHideFiduciaria) &&
                (self.validateQuest.firmatari || !self.responseQuestionario.firmaDigitale) &&
                self.validateQuest.note &&
                (self.validateQuest.fiduciarie || !self.showHideFiduciaria ||
                    ($configService.getUser() && $configService.getUser().type && $configService.getUser().type != 'ARA_ANTIRIC' && !self.responseQuestionario.metadataAdv.fiduciarie.fiduciarie.length) || self.externalLink) &&
                (self.validateQuest.fiduciante || !self.showHideFiduciaria || $configService.getUser().type != 'ARA_ANTIRIC');

        }, 200)

        functionToExport();

    }

    self.checkFiduciantiRilevati = function (hideShowFiducianti) {

        self.enableAccordionFiducianti = hideShowFiducianti
        if (!hideShowFiducianti) {
            self.validateQuest.fiduciante = true;
        }
    }

    self.closeModal = function () {
        $modalService.closeModal("validateRequest-modal");
        self.responseQuestionario.eseguiForzatura = false;
    }

    self.closeArmamentiModal = function () {
        $modalService.closeModal("domandaArmamenti-modal");
    }

    var checkCatenaSelected = function () {
        if (self.responseQuestionario && self.responseQuestionario.metadataAdv) {
            var value = self.responseQuestionario.metadataAdv.cliente &&
                self.responseQuestionario.metadataAdv.cliente.azienda &&
                self.responseQuestionario.metadataAdv.cliente.azienda.catena &&
                self.responseQuestionario.metadataAdv.cliente.azienda.catena
                    .find(function (element) {
                        return element.name.toUpperCase().trim() == 'FIDUCIARIA'
                    })
        }
        if (value && value.selected) {
            self.showHideFiduciaria = true;
        } else {
            self.showHideFiduciaria = false;
            self.validateQuest.fiduciarie = true;
        }
    }

    self.changedFinalitaFn = function () {
        self.changedFinalita = !self.changedFinalita;
    }

    self.pause = function () {
        /**
         * Parte per aggiornare il modello con Titolari Fiduciari Fiducianti ed Esecutori 
         * che sono stati inseriti successivamente a mano  
         * */
        if (self.nuoviTitolari && self.nuoviTitolari.length) {

            self.nuoviTitolari.filter(function (fid) {
                return !!fid.cf
            })
                .forEach(function (element) {
                    var checkCfIsPresent = self.responseQuestionario.metadataAdv.titolari.titolari.some(function (titolare) {
                        return titolare.cf == element.cf
                    })
                    if (!checkCfIsPresent) {
                        self.responseQuestionario.metadataAdv.titolari.titolari.push(element)
                    } else {
                        var index = self.responseQuestionario.metadataAdv.titolari.titolari.findIndex(function (titolare) {
                            return titolare.cf == element.cf
                        })
                        self.responseQuestionario.metadataAdv.titolari.titolari[index] = element

                    }
                })
        }

        if (self.nuoviEsecutori && self.nuoviEsecutori.length) {

            self.nuoviEsecutori.filter(function (fid) {
                return !!fid.cf
            }).forEach(function (element) {
                var checkCfIsPresent = self.responseQuestionario.metadataAdv.esecutori.esecutori.some(function (titolare) {
                    return titolare.cf == element.cf
                })
                if (!checkCfIsPresent) {
                    self.responseQuestionario.metadataAdv.esecutori.esecutori.push(element)
                } else {
                    var index = self.responseQuestionario.metadataAdv.esecutori.esecutori.findIndex(function (titolare) {
                        return titolare.cf == element.cf
                    })
                    self.responseQuestionario.metadataAdv.esecutori.esecutori[index] = element

                }
            })
        }

        if (self.nuoveFiduciarie && self.nuoveFiduciarie.length) {
            if (!self.responseQuestionario.metadataAdv.fiduciarie) {
                self.responseQuestionario.metadataAdv.fiduciarie = {
                    fiduciarie: []
                }
            }
            self.responseQuestionario.metadataAdv.fiduciarie.fiduciarie = self.responseQuestionario.metadataAdv.fiduciarie.fiduciarie.concat(self.nuoveFiduciarie);

            self.nuoveFiduciarie
                .filter(function (fid) {
                    return !!fid.piva
                }).forEach(function (element) {
                    var checkCfIsPresent = self.responseQuestionario.metadataAdv.fiduciarie.fiduciarie.some(function (titolare) {
                        return titolare.piva == element.piva
                    })
                    if (!checkCfIsPresent) {
                        self.responseQuestionario.metadataAdv.fiduciarie.fiduciarie.push(element)
                    } else {
                        var index = self.responseQuestionario.metadataAdv.fiduciarie.fiduciarie.findIndex(function (titolare) {
                            return titolare.piva == element.piva
                        })
                        self.responseQuestionario.metadataAdv.fiduciarie.fiduciarie[index] = element

                    }
                })
        }

        if (self.nuovoFiduciante && self.nuovoFiduciante.length) {
            if (!self.responseQuestionario.metadataAdv.fiducianti) {
                self.responseQuestionario.metadataAdv.fiducianti = {
                    fiducianti: []
                }
            }
            self.nuovoFiduciante.filter(function (fid) {
                return !!fid.cf
            }).forEach(function (element) {
                var checkCfIsPresent = self.responseQuestionario.metadataAdv.fiducianti.fiducianti.some(function (titolare) {
                    return titolare.cf == element.cf
                })
                if (!checkCfIsPresent) {
                    self.responseQuestionario.metadataAdv.fiducianti.fiducianti.push(element)
                } else {
                    var index = self.responseQuestionario.metadataAdv.fiducianti.fiducianti.findIndex(function (titolare) {
                        return titolare.cf == element.cf
                    })
                    self.responseQuestionario.metadataAdv.fiducianti.fiducianti[index] = element

                }
            })
        }
        self.responseQuestionario.metadataAdv = self.listQuestions;
        self.loading.suspend = true;
        $uniService.draftQuestAdv(self.responseQuestionario)
            .then(function (response) {
                $modalService.closeModal('suspendInstance');
                if (response.success) {
                    if (self.isPagoDopo) {
                        window.close();
                    } else if (self.isLo) {
                        self.saveDraftLo();
                    } else {
                        if (!self.isPagoDopo && !self.isLo && !self.hideInternalFooter) {
                            self.changeIndex({
                                value: 0,
                                clearSearch: true
                            })
                        } else {
                            $location.path('/')
                        }
                    }
                }
                if (self.digitalNavigator) {
                    self.digitalNavigator.loading.suspend = false;
                    self.digitalNavigator.loading.suspension = false;
                }
                self.loading.suspend = false;
            })
            .catch(function (error) {
                $modalService.closeModal('suspendInstance');
                self.loading.suspend = false;
                console.log(error);
                if (self.digitalNavigator) {
                    self.digitalNavigator.loading.suspend = false;
                    self.digitalNavigator.loading.suspension = false;
                }
            })

    }

    var functionToExport = function (fromInternalNext) {
        if (fromInternalNext) {
            if (self.nuoviTitolari && self.nuoviTitolari.length) {

                self.nuoviTitolari.forEach(function (element) {
                    var checkCfIsPresent = self.responseQuestionario.metadataAdv.titolari.titolari.some(function (titolare) {
                        return titolare.cf == element.cf
                    })
                    if (!checkCfIsPresent) {
                        self.responseQuestionario.metadataAdv.titolari.titolari.push(element)
                    }
                })
            }

            if (self.nuoviEsecutori && self.nuoviEsecutori.length) {

                self.nuoviEsecutori.forEach(function (element) {
                    var checkCfIsPresent = self.responseQuestionario.metadataAdv.esecutori.esecutori.some(function (titolare) {
                        return titolare.cf == element.cf
                    })
                    if (!checkCfIsPresent) {
                        self.responseQuestionario.metadataAdv.esecutori.esecutori.push(element)
                    }
                })
            }

            if (self.nuoveFiduciarie && self.nuoveFiduciarie.length) {
                if (!self.responseQuestionario.metadataAdv.fiduciarie) {
                    self.responseQuestionario.metadataAdv.fiduciarie = {
                        fiduciarie: []
                    }
                }
                self.responseQuestionario.metadataAdv.fiduciarie.fiduciarie = self.responseQuestionario.metadataAdv.fiduciarie.fiduciarie.concat(self.nuoveFiduciarie);

                self.nuoveFiduciarie.forEach(function (element) {
                    var checkCfIsPresent = self.responseQuestionario.metadataAdv.fiduciarie.fiduciarie.some(function (titolare) {
                        return titolare.cf == element.cf
                    })
                    if (!checkCfIsPresent) {
                        self.responseQuestionario.metadataAdv.fiduciarie.fiduciarie.push(element)
                    }
                })
            }

            if (self.nuovoFiduciante && self.nuovoFiduciante.length) {
                if (!self.responseQuestionario.metadataAdv.fiducianti) {
                    self.responseQuestionario.metadataAdv.fiducianti = {
                        fiducianti: []
                    }
                }
                self.nuovoFiduciante.forEach(function (element) {
                    var checkCfIsPresent = self.responseQuestionario.metadataAdv.fiducianti.fiducianti.some(function (titolare) {
                        return titolare.cf == element.cf
                    })
                    if (!checkCfIsPresent) {
                        self.responseQuestionario.metadataAdv.fiducianti.fiducianti.push(element)
                    }
                })
            }

            self.resetModel = !self.resetModel;
        } else {
            self.newAdded = {
                nuoviTitolari: self.nuoviTitolari,
                nuoviEsecutori: self.nuoviEsecutori,
                nuoveFiduciarie: self.nuoveFiduciarie,
                nuovoFiduciante: self.nuovoFiduciante
            }
        }

        if (self.responseQuestionario && self.responseQuestionario.metadataAdv) {
            self.responseQuestionario.metadataAdv = self.listQuestions;
        }

        var fiduciarieNonAnnullate = self.responseQuestionario.metadataAdv.fiduciarie.fiduciarie
            .filter(x => {
                return !x.annullatoFe
            });

        self.exportModelForDigital({
            responseQuestionario: self.responseQuestionario,
            enableNextButton: self.enableSubmitButton,
            newAdded: self.newAdded
        })

    }

    self.validateDocumento = function (valueOfValid) {
        self.validateQuest.documento = valueOfValid;
        checkQuestionary();
    }

    self.check = function (el) {
        el.isSelected = !el.isSelected;
    };

    self.firmaChangedFn = function () {
        self.changedSignature = !self.changedSignature;
        checkQuestionary()
    }

    // inizio procedura upload file
    self.uploader = new FileUploader({
        url: "",
        headers: {
            "Access-Control-Allow-Origin": "*",
            Token: "Bearer " + ($configService.getAppConfig().token || "no-token"),
            "App-Name": $rootScope.portalName,
        },
    });

    self.uploadDataFunc = function (item, index) {
        var document =
            arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
        if (item) {
            self.uploadData = item;
        }
        self.uploadDocumenti = document;
    };

    self.finalUpload = function () {
        self.disabledForUploadingInProgress = true;
        for (var int = 0; int < self.uploader.queue.length; int++) {
            self.uploader.queue[int].url = $configService.getAppConfig().url +
                "/uni/upload/service-infos/";
        }
        self.loadingStatus.uploading = true;
        var filesUpload = document.querySelector("#uploadInput_documentAdv").files;
        filesUpload = Object.keys(filesUpload).map(function (key) {
            return filesUpload[key];
        });
        var formData = new FormData();
        jQuery("#uploadInput_documentAdv").val("");
        filesUpload.forEach(function (file) {
            formData = new FormData();
            appendToForm(formData, "file", file);
            appendToForm(formData, "filename", file.name);
            appendToForm(formData, "idPratica", self.responseQuestionario.id);
            $financialApiService
                .uploadDocStatSocOnAdv(formData)
                .then(function (response) {
                    if (response.success) {
                        $timeout(function () {
                            var tmp = {
                                filename: file.name,
                                id: response.id,
                                cdDoc: self.uploadDocumenti.cdDocNsil,
                                downloadKey: response.downloadKey
                            };

                            self.visualProgBarDoc = false;
                            self.responseValidateRequest.uploadDoc.uploadedFiles.push(tmp);
                        }, 1);
                    } else {
                        self.visualProgBarDoc = false;
                    }
                })
                .catch(function (error) {
                    self.visualProgBarDoc = false;
                });

        });
    }

    self.generateDownloadLink = function (file) {
        var input = {};
        var url = "";
        if (file) {

            input = {
                downloadKey: file.downloadKey
            }
            url = "/uni/downloadDocDigital/service-infos/"
        } else {
            input = {};
            url = "/uni/download/service-infos/GUIDA_UPLOAD_ADV/"
        }
        $download.getGenericDownload(url, input)
            .then(function (response) {
                console.log(response)
            })

    };
    self.uploader.onWhenAddingFileFailed = function (item, filter, options) {
        console.info("onWhenAddingFileFailed", item, filter, options);
    };

    self.uploader.onAfterAddingFile = function (fileItem) {
        console.log("fileItem", fileItem);
        self.disabledForUploadingInProgress = true;
        self.progresso = 0;
        if (fileItem.file.size > 26214400) {
            $rootScope.$broadcast("addAlert", {
                text: "MAXIMUM_FILE_SIZE_EXCEEDED",
            });
            fileItem.remove();
            jQuery("uploadInput_documentAdv" + self.currentCodeTypeNameIndex).val("");
        }
        var fileName = fileItem.file.name;
        //if ( ) {
        self.uploader.queue[0].progress = 100;

        self.visualProgBarDoc = true;

        $timeout(function () {
            self.progresso = 100;
        }, 500);
        /*     } else {
              fileItem.remove();
              jQuery("uploadInput_documentAdv" + self.currentCodeTypeNameIndex).val("");
              $rootScope.$broadcast("addAlert", {
                text: "FORMAT_NOT_SUPPORTED",
              });
              self.disabledForUploadingInProgress = false;
              self.uploadInProgess({
                uploadInProgess: false,
              });
            } */
    };

    self.uploader.onAfterAddingAll = function (addedFileItems) {
        console.info("onAfterAddingAll", addedFileItems);
        self.finalUpload(self.uploadData);
    };

    self.uploader.onBeforeUploadItem = function (item) {
        item.file.name = window.encodeURIComponent(item.file.name);
        item.headers["Token"] = "Bearer " + $configService.getAppConfig().token;
        self.disabledForUploadingInProgress = true;
        self.uploadInProgess({
            uploadInProgess: true,
        });
    };

    self.uploader.onProgressItem = function (fileItem, progress) {
        self.uploadCompleted = false;
    };

    self.uploader.onProgressAll = function (progress) { };

    self.uploader.onSuccessItem = function (fileItem, response, status, headers) {
        self.loadingStatus.uploading = false;
    };

    self.uploader.onErrorItem = function (fileItem, response, status, headers) {
        console.info("onErrorItem", fileItem, response, status, headers);
        self.loadingStatus.uploading = false;
        jQuery("uploadInput_documentAdv" + self.currentCodeTypeNameIndex).val("");

        $rootScope.$broadcast("addAlert", {
            text: "ERROR_UPLOADING_FILE",
        });

        self.disabledForUploadingInProgress = false;
        self.uploadInProgess({
            uploadInProgess: false,
        });
        $timeout(function () {
            self.visualProgBarDoc = false;
        }, 1);

        fileItem.remove();
        jQuery("uploadInput_documentAdv" + self.currentCodeTypeNameIndex).val("");
    };

    self.uploader.onCancelItem = function (fileItem, response, status, headers) {
        console.log(status);
    };

    self.uploader.onCompleteItem = function (
        fileItem,
        response,
        status,
        headers
    ) {
        console.info("onCompleteItem", fileItem, response, status, headers);
        if (
            response &&
            response.uploadFileServicePojo &&
            response.uploadFileServicePojo.success
        ) {
            self.uploadOk = true;
            console.log(fileItem);

            var document = {
                fileStatus: null,
                isSelected: false,
                nameFile: response.uploadFileServicePojo.fileName,
                uuid: "",
                errorMessage: "",
                documentClass: "",
            };

            self.listOfFilesUpload = response.metadataUniUpload.uploadedfile.sort(
                function (a, b) {
                    if (a.codiceDocNSIL > b.codiceDocNSIL) {
                        return 1;
                    } else {
                        return -1;
                    }
                }
            );
        }
        self.uploader.queue = [];

        $timeout(function () {
            self.visualProgBarDoc = false;

            self.disabledForUploadingInProgress = false;
            self.uploadInProgess({
                uploadInProgess: false,
            });
        }, 1);
        jQuery("uploadInput_documentAdv" + self.currentCodeTypeNameIndex).val("");
    };

    self.uploader.onCompleteAll = function () {
        console.info("onCompleteAll");
        self.uploadCompleted = true;
    };

    self.uploader.onSuccessItem = function (fileItem, response, status, headers) {
        self.uploading = false;
    };

    self.deletePrivacyDocument = function (index) {
        self.progresso = 100;

        self.visualProgBarDoc = true;

        $timeout(function () {
            self.progresso = 0;
        }, 200);

        self.documentsToBeDeleted = self.responseValidateRequest.uploadDoc.uploadedFiles
            .filter(function (elem) {
                return elem.isSelected == true;
            });


        self.documentsToBeDeleted.forEach(function (element) {
            var checklistType = undefined;
            $simulationService
                .deleteChecklistFileDigital(element.id, checklistType)
                .then(function (response) {
                    console.log(response);
                    if (response.success) {
                        $timeout(function () {
                            self.visualProgBarDoc = false;
                            self.responseValidateRequest.uploadDoc.uploadedFiles = self.responseValidateRequest.uploadDoc.uploadedFiles
                                .filter(function (e) {
                                    return e.isSelected != true;
                                });

                        }, 1);
                    } else {
                        self.visualProgBarDoc = false;
                    }
                })
                .catch(function (error) {
                    self.visualProgBarDoc = false;
                });
        });
    };

    self.genericTrashCheck = function () {
        return (
            self.responseValidateRequest.uploadDoc &&
            self.responseValidateRequest.uploadDoc.uploadedFiles &&
            self.responseValidateRequest.uploadDoc.uploadedFiles.some(function (element) {
                return element.isSelected == true;
            })
        );
    }

    var getEventLog = (idPractice) => {

        self.loaderEventSection = true;

        $uniService.getEvents(idPractice)
            .then(response => {
                self.loaderEventSection = false;
                self.responseGetEvent = response;
            })
            .catch(error => {
                console.log(error);
                self.loaderEventSection = false;
            })
    }

    $scope.$on('titolareChanged', function (e, pef) {
        if (self.listQuestions.cliente.common.legalForm == 'PEF') {
            self.listQuestions.cliente.persona.annullato = pef.annullato;
            self.listQuestions.cliente.common.annullato = pef.annullato;
            self.listQuestions.cliente.persona.annullatoFe = pef.annullatoFe;
            self.listQuestions.cliente.common.annullatoFe = pef.annullatoFe;
            self.listQuestions.cliente.persona.cf = pef.cf;
            self.listQuestions.cliente.common.cf = pef.cf;
            self.listQuestions.cliente.persona.cognome = pef.cognome;
            self.listQuestions.cliente.persona.data = pef.data;
            self.listQuestions.cliente.common.data = pef.datiNascita.data;
            self.listQuestions.cliente.persona.datiNascita = pef.datiNascita;
            self.listQuestions.cliente.persona.datiNascita.cittadinanza = pef.cittadinanza;
            self.listQuestions.cliente.persona.datiNascita.comune = pef.datiNascita.luogoEsteso.nome;
            self.listQuestions.cliente.persona.documento = pef.documento;
            self.listQuestions.cliente.persona.domicilio = pef.domicilio;
            self.listQuestions.cliente.persona.domicilioDiverso = pef.domicilioDiverso;
            self.listQuestions.cliente.persona.editabile = pef.editabile;
            self.listQuestions.cliente.common.editabile = pef.editabile;
            self.listQuestions.cliente.persona.fromDossier = pef.fromDossier;
            self.listQuestions.cliente.persona.nome = pef.nome;
            self.listQuestions.cliente.persona.pep = pef.pep;
            self.listQuestions.cliente.persona.ragioneSociale = pef.ragioneSociale;
            self.listQuestions.cliente.common.ragioneSociale = pef.cognome;
            self.listQuestions.cliente.persona.sedeLegale = pef.sedeLegale;
            self.listQuestions.cliente.common.sedeLegale = pef.sedeLegale;
            self.listQuestions.cliente.persona.sedeLegale = pef.sedeLegale;
            self.listQuestions.cliente.persona.sesso = pef.sesso;
        }
    });

}